import * as React from 'react';
// import ConfiguredGoogleWrapper  from 'src/services/google-maps';
import axios from 'axios';
import './LocationInput.scss';
import _config from 'src/services/google-maps/config';
import { compose, withProps, lifecycle } from 'recompose';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import LoadingFrame from 'src/components/LoadingFrame';

const { SearchBox } = require('react-google-maps/lib/components/places/SearchBox');
const config = _config({});
const googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${config.apiKey}` + 
 `&v=3.exp&libraries=geometry,drawing,places`;

const MapWithASearchBox = compose(
  withProps({
    googleMapURL,
    loadingElement: <LoadingFrame name="grid" />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  lifecycle({
    componentWillMount() {
      const me  = this;
      const refs: any = {};
      const { lat, lng, name, onLocationChange } = this.props;

      const _setAutoCompleteWhenLoad = function(_me: any, newValue: any) {
          if (_me.input) {
            _me.input.value = newValue;
          } else {
              setTimeout(_setAutoCompleteWhenLoad.bind(_me, _me, newValue), 250);
          }
      };
      const setAutoCompleteWhenLoad = _setAutoCompleteWhenLoad.bind(me, me);

      let geocode = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=';
      geocode += `${this.props.lat},${this.props.lng}&key=${config.apiKey}`;

      axios.post(geocode).then(res => {
          const data = res.data.results;
          if (data.length > 0) {
              let address = data[0].formatted_address;
              setAutoCompleteWhenLoad(address);
          }
      });        

      const position = { lat, lng };

      this.setState({
        bounds: null,
        center: position,
        markers: [{position}],
        onMapMounted: ref => {
          refs.map = ref;
        },
        onBoundsChanged: () => {
          this.setState({
            bounds: refs.map.getBounds(),
            center: refs.map.getCenter(),
          });
        },
        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },
        onPlacesChanged: () => {
          const places = refs.searchBox.getPlaces();
          const bounds = new google.maps.LatLngBounds();
          let setPlace = true;

          places.forEach((place) => {
            if (setPlace) {
                const value = place.geometry.location;
                const data = {name, value};
                onLocationChange({}, data); 
                setPlace = false;
            }
            if (place.geometry.viewport) {
              bounds.union(place.geometry.viewport);
            } else {
                bounds.extend(place.geometry.location);
            }
          });

          const nextMarkers = places.map(place => ({
            position: place.geometry.location,
          }));

          const nextCenter = (nextMarkers[0] || {}).position || this.state.center;

          this.setState({
            center: nextCenter,
            markers: nextMarkers,
          });
          // refs.map.fitBounds(bounds);
        },
        setInput: (input) => {
            me.input = input;
        }
      });
    },
  }),
  withScriptjs,
  withGoogleMap
)(props => (
    <GoogleMap
        ref={props.onMapMounted}
        defaultZoom={15}
        center={props.center}
        onBoundsChanged={props.onBoundsChanged}
    >
        <SearchBox
            ref={props.onSearchBoxMounted}
            bounds={props.bounds}
            controlPosition={google.maps.ControlPosition.TOP_LEFT}
            onPlacesChanged={props.onPlacesChanged}
        >
        <input
            type="text"
            placeholder="Start typing your location"
            ref={props.setInput}
            style={{
                boxSizing: `border-box`,
                border: `1px solid transparent`,
                width: `240px`,
                height: `32px`,
                marginTop: `27px`,
                padding: `0 12px`,
                borderRadius: `3px`,
                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                fontSize: `14px`,
                outline: `none`,
                textOverflow: `ellipses`,
            }}
        />
        </SearchBox>
        {props.markers.map((marker, index) =>
        <Marker key={index} position={marker.position} />
        )}
    </GoogleMap>
));

// class LocationInput extends React.Component<any, any> {
//     autocomplete: any;
//     state = {
//         position: null
//     };

//     constructor(props: any) {
//         super(props);
//         this.props.onLocationChange({}, {name: props.name, value: {
//             lat: props.lat,
//             lng: props.lng
//         }});
//     }

//     componentDidMount() {
//         const me  = this;
//         const setAutoCompleteWhenLoad = me.setAutoCompleteWhenLoad.bind(me);
//         let geocode = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=';
//         geocode += `${this.props.lat},${this.props.lng}&key=${config.apiKey}`;

//         axios.post(geocode).then(res => {
//             const data = res.data.results;
//             if (data.length > 0) {
//                 let address = data[0].formatted_address;
//                 setAutoCompleteWhenLoad(address);
//             }
//         });
//         this.renderAutoComplete();
        
//     }

//     setAutoCompleteWhenLoad(newValue: any) {
//         if (this.autocomplete) {
//             this.autocomplete.value = newValue;
//         } else {
//             setTimeout(this.setAutoCompleteWhenLoad.bind(this, newValue), 250);
//         }

//     }

//     componentDidUpdate(prevProps: any) {
//         if (this.props !== prevProps.map) {
//             this.renderAutoComplete();
//         }
//     }

//     renderAutoComplete() {
//         const { google, map } = this.props;

//         if (!google || !map) { 
//             return;
//         }
        
//         const autocomplete = new google.maps.places.Autocomplete(this.autocomplete);
//         autocomplete.bindTo('bounds', map);

//         autocomplete.addListener('place_changed', (e) => {
//             const place = autocomplete.getPlace();

//             if (!place.geometry) {
//                 return;
//             }

//             if (place.geometry.viewport) {
//                 map.fitBounds(place.geometry.viewport);
//             } else {
//                 map.setCenter(place.geometry.location);
//                 map.setZoom(17);
//             }

//             this.setState({ position: place.geometry.location });

//             if (this.props.onLocationChange) {
//                 this.props.onLocationChange(e, {name: this.props.name, value: {
//                     lat: place.geometry.location.lat(),
//                     lng: place.geometry.location.lng()
//                 }});
//             }
//         });
//     }

//     render() {
//         const { position } = this.state;

//         return (
//             <div>
//                 <Form.Input>
//                     <input 
//                         type="text" 
//                         placeholder="Start Entering Location"
//                         ref={ref => (this.autocomplete = ref)}
//                     />
//                 </Form.Input>
                
//                 <Map
//                     {...this.props}
//                     center={position}
//                     initialCenter={ 
//                         (
//                             typeof this.props.lat === 'undefined'
//                             || typeof this.props.lng === 'undefined'
//                         ) ?
//                         {
//                             lat: -36.9448729,
//                             lng: 174.63055269999995
//                         }
//                         : this.props  
//                     }
//                     centerAroundCurrentLocation={false}
//                     containerStyle={{
//                         height: '35vh',
//                         position: 'relative',
//                         width: '35$',
//                         marginTop: '21px'
//                     }}
//                 >
//                     <Marker position={position} />
//                 </Map>
//             </div>
//         );
//     }
// }

const MapWrapper = props => (
    <MapWithASearchBox
        {...props}  
        {... ( typeof props.lat === 'undefined' || typeof props.lng === 'undefined' ) ?
            {
                lat: -36.9448729,
                lng: 174.63055269999995 // co-ordinate for corr-systems
            }
            : { }   
        } 
    />
);

export default MapWrapper;


// WEBPACK FOOTER //
// ./src/components/inputs/LocationInput.tsx